import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-47484594"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container text-center long-container"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "img-container"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "caption long-caption"
};
var _hoisted_6 = {
  class: "date"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["row", {
      'active-list-trends': $setup.isShowTrends
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, function (n) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["col-sm-6 col-md-4", {
        'active-list-news': $setup.isShowNews
      }]),
      key: n.id
    }, [_createVNode(_Transition, {
      name: "newsList",
      appear: "",
      class: "animate__animated",
      "enter-active-class": "animate__fadeInUp"
    }, {
      default: _withCtx(function () {
        return [_createElementVNode("div", {
          class: "thumbnail long-thumbnail",
          onClick: function onClick($event) {
            return $setup.goNewsDetail(n);
          }
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          src: n.imgUrl,
          alt: "companyNew"
        }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", null, _toDisplayString(n.title), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(n.releaseDate), 1)])], 8, _hoisted_2)];
      }),
      _: 2
    }, 1024)], 2);
  }), 128))], 2)]);
}